"use client";

import { breakpointTablet, Heading2Text } from "@gnist/design-system";
import { styled } from "styled-components";
import { Collapse } from "@/components/collapse";
import { isMobile } from "@/utils/isMobile";
import { tokens } from "@gnist/themes/tokens.css.js";

interface Props {
  equipment: string[];
}

const Wrapper = styled.div`
  max-width: 704px;

  h3 {
    padding-bottom: ${tokens.spacing.s};
    @media screen and (max-width: ${breakpointTablet}) {
      font-size: ${tokens.typeface.size.m};
    }
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  column-gap: ${tokens.spacing.s};
  row-gap: ${tokens.spacing.s};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(33% - ${tokens.spacing.xs});
  word-wrap: break-word;

  @media screen and (max-width: ${breakpointTablet}) {
    width: 100%;
  }
`;

export const Equipment = ({ equipment }: Props) => {
  return (
    <Wrapper>
      <Heading2Text>Utstyr</Heading2Text>
      {isMobile() ? (
        <Collapse
          id="equipment-wrapper"
          backgroundColorToken={tokens.color.background}
          collapsedHeight="300"
          buttonLabel={{ collapse: "Vis mindre", expand: "Vis mer" }}
          showCollapsedOverlay={false}
        >
          <ItemsWrapper>
            {equipment.map((item) => (
              <Item key={item}>{item}</Item>
            ))}
          </ItemsWrapper>
        </Collapse>
      ) : (
        <ItemsWrapper>
          {equipment.map((item) => (
            <Item key={item}>{item}</Item>
          ))}
        </ItemsWrapper>
      )}
    </Wrapper>
  );
};
